// modules
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { addModal } from 'weblite-web-modal-viewer'
// component
import { HallProfileMenu } from './hall-profile-menu'

const COMPONENT_ID = 'hallProfileMenu'

interface Prop {
  hallId: string
}

export const showHallProfileMenu = (props: Prop, preventBackClick = false) =>
  addModal({ id: COMPONENT_ID, props, preventBackClick })

export default {
  [COMPONENT_ID]: { Component: HallProfileMenu },
}
